/**
 * Init js selector
 *
 * @param mode [async, synch]
 */
function initCustomSelect(mode = 'async'){
    var selects = document.querySelectorAll('.my-select-wrapper, .venue-type-wrapper');
    if (selects !== null) {
        for(const select of selects) {
            select.addEventListener('click', function (e) {
                var triggerSelector = '.my-select__trigger, .venue-type__trigger';
                if (e.target.classList.contains('my-select__trigger') ||
                    e.target.classList.contains('venue-type__trigger') ||
                    e.target.closest(triggerSelector) !== null) {
                    e.stopImmediatePropagation();
                    current_selector = this.querySelector('.my-select, .venue-type');
                    if(current_selector.classList.contains('open')){
                        current_selector.classList.remove('open');
                    } else {
                        current_selector.classList.add('open');
                    }
                }
            }, true) // true to prevent conflict with option click
            for (const option of document.querySelectorAll(".custom-option")) {
                option.addEventListener('click', function (e) {
                    if (!this.classList.contains('selected')) {
                        document.querySelectorAll('.my-select, .venue-type').forEach(function(element){
                            element.classList.remove('open');
                        });
                        if(mode === "async") {
                            var selected = this.parentNode.querySelector('.custom-option.selected');
                            if(selected !== null) {
                                selected.classList.remove('selected');
                            }
                            this.classList.add('selected');
                            var triggerSpan = this.closest('.my-select, .venue-type').querySelector('.my-select__trigger span, .venue-type__trigger span');
                            if(triggerSpan) {
                                triggerSpan.innerHTML = this.innerHTML;
                            }
                        }
                        // Sync value for all selects in a page.
                        if(mode === "sync") {
                            var value = this.getAttribute('data-value');
                            var all_options = document.querySelectorAll('.my-select-wrapper .custom-options .custom-option, .venue-type-wrapper .custom-options .custom-option');
                            for (const option of all_options){
                                option.classList.remove('selected');
                                if(option.getAttribute('data-value') === value){
                                    option.classList.add('selected');
                                    var triggerSpan = option.closest('.my-select, .venue-type').querySelector('.my-select__trigger span, .venue-type__trigger span');
                                    if(triggerSpan) {
                                        triggerSpan.innerHTML = this.innerHTML;
                                    }
                                }
                            }
                        }
                    } else {
                        this.classList.remove('selected');
                    }
                })
            }
            window.addEventListener('click', function (e) {
                const selects = document.querySelectorAll('.my-select, .venue-type');
                selects.forEach(function(select) {
                    if (!select.contains(e.target)) {
                        select.classList.remove('open');
                    }
                });
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initCustomSelect();
});